var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.856 38.1782C47.5524 38.1782 48.9275 39.5534 48.9275 41.2497V45.8568C48.9275 47.5531 47.5524 48.9282 45.856 48.9282H15.1417C13.4454 48.9282 12.0703 47.5531 12.0703 45.8568V41.2497C12.0703 39.5533 13.4455 38.1782 15.1417 38.1782H45.856Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.498 12.071C32.1943 12.071 33.5694 13.4462 33.5694 15.1425V28.9639C33.5694 30.6602 32.1943 32.0353 30.498 32.0353H14.9308C13.2345 32.0353 11.8594 30.6602 11.8594 28.9639L11.8594 15.1425C11.8594 13.4462 13.2345 12.071 14.9308 12.071H30.498Z",
    stroke: "#56EE99",
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2953 12.071C48.1437 12.071 48.831 12.7586 48.831 13.6068V17.446C48.831 18.2942 48.1437 18.9818 47.2953 18.9818H41.2486C40.4006 18.9818 39.7129 18.2942 39.7129 17.446V13.6068C39.7129 12.7586 40.4006 12.071 41.2486 12.071H47.2953Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2953 25.1246C48.1437 25.1246 48.831 25.8121 48.831 26.6603V30.4996C48.831 31.3477 48.1437 32.0353 47.2953 32.0353H41.2486C40.4006 32.0353 39.7129 31.3477 39.7129 30.4996V26.6603C39.7129 25.8121 40.4006 25.1246 41.2486 25.1246H47.2953Z",
    stroke: "#56EE99",
    strokeWidth: 2.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesDashboard);
export default __webpack_public_path__ + "static/media/ResourcesDashboard.3f79b75ccd78e9ff04721b61c7a7dc59.svg";
export { ForwardRef as ReactComponent };